export default __webpack_public_path__ + "images/188da17ca7192228c1a0a52a64ecb96e-search_sp3_1@2x.png";